exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ecomotoriMap a{color:#000}#ecomotoriMap .add-poi{display:block;text-align:center}#ecomotoriMap .poi-footer{font-size:14px}#ecomotoriMap .poi-footer p{line-height:8px}", ""]);

// exports
